<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <b-tabs 
            lazy
            no-nav-style
            nav-class="spl-page-nav border-bottom"
            content-class="py-3"
        >  <!-- lazy to avoid it all loading at once -->
            <template #tabs-start>
                <div class="d-flex align-items-end justify-content-start pb-2 mr-4" style="border-bottom: 3px solid transparent;">
                    <h4 class="mb-0 text-primary-darker font-weight-700">Quality</h4>
                </div>
            </template>
            <b-tab title="Quality Issues">
                <!-- This gets all its info from currentUserInfo -->
                <h5>Active Quality Issues</h5>
                <my-quality-issues
                    v-if="showMixedQualityList"
                    :fixed-per-page="10"
                ></my-quality-issues>  <!-- can use hide-fields but we'll show all of them here -->
                <portal-workflow-run-list
                    v-else key="dwf_quality_run_list"
                ></portal-workflow-run-list>
            </b-tab>
            <b-tab v-if="showScorecards && qualityScorecardSystemId" title="Scorecard">
                <!-- must use v-if on this in case there is no SCS for this tenant/vendor -- id will be null or empty string -->
                <b-alert :show="showScorecardsVendorTesting" variant="danger" class="text-center font-weight-bold">
                    Scorecards below are FOR TESTING ONLY
                </b-alert>
                <scorecard-vendor-summary
                    :system-id="qualityScorecardSystemId"
                    :vendor-id="companyId"
                    :hide-chart="false"
                    descending
                    class="bg-gray-200 border rounded-lg px-4 py-3"
                ></scorecard-vendor-summary>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { errorHandling, tenantInfoMixin } from '../../js/custom-vue-mixins';
import MyQualityIssues from '../dashboard/MyQualityIssues.vue';
import PortalWorkflowRunList from './PortalWorkflowRunList.vue'

export default {
    name: 'PortalDashboardQuality',
    components: {
        PortalWorkflowRunList,
        MyQualityIssues,
    },
    mixins: [
        errorHandling,
        tenantInfoMixin,
    ],
    props: {
        companyId: {
            // could get from currentUserInfo, but we'll make it explicit for now so this component is reusable in internal things too
            type: String,
            required: true,
        },
        qualityScorecardSystemId: {
            // might be null if there is no scorecard system enabled / available for this company
            type: String,
            required: false,  // false because tenant might not have one
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            
        }
    },
    computed: {
        showMixedQualityList() {
            // maybe change this if/when you completely remove old quality DWFs
            return !!this.$tenantInfo.custom_flags.show_new_quality;
        },
        showScorecards() {
            return !!this.$tenantInfo.custom_flags.show_scorecards;
        },
        showScorecardsVendorTesting() {
            return this.$tenantInfo?.custom_flags?.show_scorecards_vendor_testing === true;
        },
    },
    mounted() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

    }
}
</script>

<style>

</style>